import { render, staticRenderFns } from "./BdcDownloadButton.vue?vue&type=template&id=785115a0"
import script from "./BdcDownloadButton.vue?vue&type=script&lang=js"
export * from "./BdcDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports